import {BaseService} from "./base.service";

class LegalService extends BaseService {

    constructor() {
        super('api/legal-terms')
    }

    setRoute(_route) {
        this.url = `${_route}`;
    }

}

export const legalService = new LegalService();
